<template lang="pug">
  //- Archive (was Text, build brief D1/D2): the CV-style index, layout unchanged, weight and colour quieter
  section.archive.pt-72.md-pt-144.px-12
    //- projects
    article.relative.flex(v-for="(prj, i) in prjsByMuralDate", :key="i", v-if="prj.data")
      //- title
      router-link.archive__item.flex-1.lg-w-9x18.block.px-12.type-caption.leading-looser.trans-color-fast.pointer-events-auto(:to="{name: 'project', params: {uid: prj.uid}}")
        h3 <i>{{ txt(prj.data.title) }}</i>, {{ txt(prj.data.location) }}, {{ prjYear(prj) }}
      //- hover image
      figure.archive__preview.hidden.md-block.w-4x18.pl-24.pr-12.opacity-0.order-first
        .relative(v-if="prj.data._index_image")
          resp-img.absolute.w-full(:lazy="true", :src="prj.data._index_image.url", :alt="prj.data._index_image.alt", :blurLoad="false")
</template>

<script>
import RespImg from '@/components/RespImg'
import { prjYear } from '@/utils'
import get from 'lodash/get'
export default {
  name: 'ProjectsByText',
  props: ['prjs'],
  data () {
    return {
      txt: this.$prismic.richTextAsPlain,
      prjYear
    }
  },
  computed: {
    prjsByMuralDate () {
      return this.prjs.slice().sort((a, b) => {
        a = new Date(get(a, 'data.mural_completion_date'))
        b = new Date(get(b, 'data.mural_completion_date'))
        return a < b ? 1 : a > b ? -1 : 0
      })
    }
  },
  components: { RespImg }
}
</script>

<style>
/*
 * D2: normal weight everywhere, and no weight change on hover (the medium weight made the line jump wider).
 * Two treatments for Guido to compare:
 *   default            grey at rest, black on hover
 *   ?archive=black     black at rest, the rest of the list fades to grey while one is hovered
 */
.archive__item {
  font-weight: 400;
  color: var(--gray-500);
}
.archive__item:hover { color: black; }

html[data-archive="black"] .archive__item { color: black; }
@media (hover: hover) {
  html[data-archive="black"] .archive:hover .archive__item { color: var(--gray-500); }
  html[data-archive="black"] .archive .archive__item:hover { color: black; }
}

.archive__preview { transition: opacity 100ms; }
.archive article:hover .archive__preview { transition: opacity 300ms 100ms; }
@media (hover: hover) {
  .archive article .archive__item:hover + .archive__preview { opacity: 1; }
}
</style>
